export const types = {
  USERLOGIN_AUTH: "@AUTH/USERLOGIN",
  USERLOGIN_AUTH_SUCCESS: "@AUTH/USERLOGIN/SUCCESS",
  USERLogout_AUTH_SUCCESS: "@AUTH/USERLOGOUT/SUCCESS",
  USER_CURRENT_MENU: "@LOGIN/USER_CURRENT_MENU",
  USERSIGNUP_AUTH: "@/USERSIGNUP_AUTH",
  USERSIGNUP_AUTH_SUCCESS: "@/USERSIGNUP_AUTH_SUCCESS",

  GET_LOGGEDIN_PROFILE: "@LAYOUT/GET_LOGGEDIN_PROFILE",
  GET_TRANSLATION_CACHE: '@/TRANSLATION/GET_TRANSLATION_CACHE',
  GET_TRANSLATION_CACHE_SUCCESS: '@/TRANSLATION/GET_TRANSLATION_CACHE_SUCCESS',
  GET_LOGGEDIN_PROFILE_SUCCESS: "@LAYOUT/GET_LOGGEDIN_PROFILE_SUCCESS",
  SET_MENUHIERARCHY: "@LAYOUT/SET_MENUHIERARCHY",
  SET_CURRENTSITE: "@LAYOUT/SET_CURRENTSITE",
  SET_LandingPage: "@LAYOUT/SET_LandingPage",
  SET_UserDetails: "@LAYOUT/SET_UserDetails",
  SET_MenuCollapse: "@LAYOUT/SET_MenuCollapse",
  SET_TIMEZONE: "@LAYOUT/SET_TIMEZONE",
  GET_DefaultHierarchy: "@LAYOUT/GET_DefaultHierarchy",
  SET_MENU_SELECTION: "@LAYOUT/SET_MENU_SELECTION",
  SET_DEFAULTIMEOUT: "@LAYOUT/SET_DEFAULTIMEOUT",

  ASSET_CACHE: "@/ASSET_CACHE",
  ASSET_CACHE_SUCCESS: "@/ASSET_CACHE_SUCCESS",
  ASSET_DEVICE_LIST: "@/ASSET_DEVICE_LIST",
  DEVICE_CACHE_SUCCESS: "@/DEVICE_CACHE_SUCCESS",
  CREATE_ASSET: "@/CREATE_ASSET",
  UPDATE_ASSET: "@/UPDATE_ASSET",
  DELETE_ASSET: "@/DELETE_ASSET",
  SET_CURRENTLANGUAGE: "@/SET_CURRENTLANGUAGE",
  Current_ASSET: "@/Current_ASSET",
  SET_BREADCRUMB_LIST: "@/SET_BREADCRUMB_LIST",
  BREADCRUMB_LIST: "@/BREADCRUMB_LIST",

  DEVICE_LIST: "@/DEVICE_LIST",
  CREATE_DEVICE: "@/CREATE_DEVICE",
  UPDATE_DEVICE: "@/UPDATE_DEVICE",
  DELETE_DEVICE: "@/DELETE_DEVICE",
  Current_Device: "@/Current_Device",
  DEVICE_LIST_SUCCESS: "@/DEVICE_LIST_SUCCESS",
  DEVICE_LIST_CM: "@/DEVICE_LIST_CM",
  DEVICE_CM_LIST_SUCCESS: "@/DEVICE_CM_LIST_SUCCESS",
  SETDEVICE_BREADCRUMB_LIST: "@/SET_DEVICE_BREADCRUMB",
  GET_TAGREFERENCE_LIST: "@/GET_TAGREFERENCE_LIST",
  GET_TAGREFERENCE_LIST_SUCCESS: "@/GET_TAGREFERENCE_LIST_SUCCESS",

  GET_DEVICETYPE: '@/GET_DEVICETYPE',
  GET_DEVICETYPE_SUCCESS: '@/GET_DEVICETYPE_SUCCESS',
  SAVE_DEVICETYPE: '@/SAVE_DEVICETYPE',
  UPDATE_DEVICETYPE: '@/UPDATE_DEVICETYPE',
  DELETE_DEVICETYPE: '@/DELETE_DEVICETYPE',
  SAVE_DEVICEPARAMETERS: '@/SAVE_DEVICEPARAMETERS',
  DELETE_DEVICEPARAMETERS: '@/DELETE_DEVICEPARAMETERS',
  GET_DEVICETYPE_CM: '@/GET_DEVICETYPE_CM',
  GET_DEVICETYPE_CM_SUCCESS: '@/GET_DEVICETYPE_CM_SUCCESS',


  THEME: '@THEME/CHANGE',
  THEMEING: '@THEMEING/CHANGE',
  NAVIGATION_MODE: '@NAVIGATION_MODE',


  NAVIGATE: '@NAVIGATE',
  CLEAR_NAVIGATION: '@CLEAR_NAVIGATION',
  NavigationSuccess: '@/NavigationSuccess'
};
